let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jybPN")).then(() => parcelRequire('ggW8r'));